import MimSetupV2 from './MimSetupV2'

export default function MimSetup() {
  return <MimSetupV2 />
}
